'use client'
import ErrorPage from "../../../../partials/error";

export default function Error({error, reset}) {
    // Parse errorType from error.digest (error.message is stripped by Next.js
    // in production for server-thrown errors, but digest is preserved).
    let errorType = "default";
    const match = error?.digest?.match(/errorType:(\w+)/);
    if (match) {
        errorType = match[1];
    }

    return <ErrorPage error={error} reset={reset} errorType={errorType} />
}